export default __webpack_public_path__ + "static/media/Numbers_Large_Blurred.9bf37803.png";